<div class="body ui container" fxLayout="column">
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <!-- <div class="ui divider" appMargin marginY="3"></div> -->
  <div class="ui success message">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <p>
      VITAL UPDATE: The account details for invoices in US Dollars have been
      revised. Kindly utilize the updated information for your payment.
      <a target="_blank" href="/home-page/foreign-details">Click here</a> to
      access the updated account details.
    </p>
  </div>
  <div [suiCollapse]="!advancedSearchVisible" appMargin marginY="3">
    <div class="ui segment">
      <app-search-filter-null
        [headers]="headers"
        searchName="Invoice"
        (onCancel)="advancedSearchVisible = !advancedSearchVisible"
        (submitSearch)="advancedSearch($event)"
      ></app-search-filter-null>
    </div>
  </div>

  <!-- <div class="ui segment" style="border-radius: 4px;" appMargin marginT="0"> -->
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <!-- </div> -->

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="15px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="20">INVOICE NO.</div>
      <div fxFlex="40">SERVICE TYPE</div>
      <div fxFlex="20">INVOICE AMOUNT</div>
      <div fxFlex="15">OUTSTANDING AMOUNT.</div>
      <div fxFlex="10">NO. OF PAYMENT</div>
      <div fxFlex="15">STATUS</div>
      <div fxFlex="13%"></div>
    </div>

    <app-invoice-row
      [department]="s"
      *ngFor="let s of invoices"
      (onView)="viewDepartment($event)"
      (onPayNow)="getPayment($event)"
      (onDownload)="download($event)"
    ></app-invoice-row>

    <app-no-record-found
      *ngIf="invoices && invoices.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui labeled button">
            <div class="ui tiny icon button" (click)="getPage(1)">
              <i class="refresh icon"></i>
            </div>
            <a class="ui basic label"> {{ totalItems }} Record(s) </a>
          </div>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="mini"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
